import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DDLDataTable } from "../../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { IScreenPermissions } from "../../../models";
import { ScreenPermissionsInfoSetupFieldsPanel } from "./Panels/ScreenPermissionsInfoSetupFieldsPanel";
import { ScreenPermissionsService } from "../../../services/RoleManagementServices/ScreenPermissionsService";
import { ScreenPermissionsSetupToolbar } from "./ScreenPermissionsSetupToolbar";
import { ScreenPermissionsSetupValidationSchema } from "./validator";
import { ScreenService } from "../../../services/RoleManagementServices/ScreenService";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";




export interface IScreenPermissionsSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "screem-permissions-single-data-record";
const SCREEN_PERMISSIONS_LIST_DATA_QUERY_KEY = "screen-permissions-list";

const useGetData = (
	clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, clientId, id, navigateToLogout],
		queryFn: () => {
			return ScreenPermissionsService.getById(clientId, id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useScreenPermissions = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SCREEN_PERMISSIONS_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return ScreenPermissionsService.getScreenPermissions(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetScreensDDL = () =>
	useQuery({
		queryKey: ["screens-DDL"],
		queryFn: (data) => {
			return ScreenService.getScreensDDL();
		},
		refetchOnWindowFocus: false,
	});
export const ScreenPermissionsSetup: React.FC<IScreenPermissionsSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [screenPemrissionsId, setScreenPermissionsId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useScreenPermissions(
		clientId,
		queryParams,
		navigateToLogout
	);

	const screenPemrissionsList: any | null = data;

	const { isPending: isPendingScreensDDL, data: screensDDL } =
		useGetScreensDDL();

	const { isPending: isSubmitting, mutate: submitScreenPermissionsFormFields } =
		useMutation({
			mutationFn: ScreenPermissionsService.create,
			onSuccess: (res: IScreenPermissions | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIScreenPermissionsResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					// let path = `/role-management/screen-permissions/${res.data.id}`;
					// navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [SCREEN_PERMISSIONS_LIST_DATA_QUERY_KEY],
						}),
						// queryClient.invalidateQueries({
						// 	queryKey: ["screens-DDL"],
						// }),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIScreenPermissionsResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					// let path = `/role-management/screen-permissions/${res.data.id}`;
					// navigate(path);
					// setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [SCREEN_PERMISSIONS_LIST_DATA_QUERY_KEY],
						}),
						// queryClient.invalidateQueries({
						// 	queryKey: ["screens-DDL"],
						// }),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		clientId,
		editRecordId,
		navigateToLogout
	);

	const upadtedScreenPermissionsListItems = useMemo(() => {
		return (
			screenPemrissionsList &&
			screenPemrissionsList.items &&
			screenPemrissionsList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/role-management/screen-permissions/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.name}
					</Link>
				),
			}))
		);
	}, [screenPemrissionsList]);


	const DEFAULT_VALUES = {
		screenId: undefined,
		name: undefined,
		values: undefined,

	};

	const formMethods = useForm<any>({
		resolver: yupResolver(ScreenPermissionsSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {
		const screens = values.screenId
			.map((id: string) => screensDDL && screensDDL.find((item: any) => item.value === id))
			.filter(Boolean)
			.map((item: any) => ({
				screenId: item.value,
				screenName: item.slug
			}));

		const valuesInArray = values.values && values.values.split(',').map((v: any) => v.trim());
		let payload = {
			id: id && id,
			navigateToLogout: navigateToLogout,
			// screenId: values.screenId,
			screens: screens,
			name: values.name,
			type: values.values ? "list" : "switch",
			values: values.values ? valuesInArray : undefined,
		};

		submitScreenPermissionsFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {
			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "screenId") {
					// const screenIds = fieldValue.map((item: any) => item.screenId);
					// formMethods.setValue(fieldName, screenIds);
					formMethods.setValue(fieldName, [fieldValue]);
				}
				if (fieldName === "type") {
					formMethods.setValue("permissionType", fieldValue === "switch" ? true : false);
				}
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteScreenPermissionsById } = useMutation({
		mutationFn: ScreenPermissionsService.delScreenPermissions,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the ScreenPermissions fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/screen-permissions`;
			navigate(path);
			return Promise.all([
				queryClient.invalidateQueries({
					queryKey: [SCREEN_PERMISSIONS_LIST_DATA_QUERY_KEY],
				}),
				queryClient.invalidateQueries({
					queryKey: ["screens-DDL"],
				}),
			]);
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteScreenPermissionsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				screenPemrissionsId: screenPemrissionsId,
				navigateToLogout: navigateToLogout,
			};
			deleteScreenPermissionsById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setScreenPermissionsId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setScreenPermissionsId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveScreenPermissionsById } = useMutation({
		mutationFn: ScreenPermissionsService.archiveScreenPermissions,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the ScreenPermissions fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/screen-permissions`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [SCREEN_PERMISSIONS_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveScreenPermissionsField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				screenPemrissionsId: screenPemrissionsId,
				navigateToLogout: navigateToLogout,
			};
			archiveScreenPermissionsById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setScreenPermissionsId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/role-management/screen-permissions`;
		navigate(path);
	};

	const expandedLabels = ["Role Management"];
	const expandedScreenPermissionsSetupItem = "Screen Permissions"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Screen Permissions" &&
				item.label === expandedScreenPermissionsSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedScreenPermissionsSetupItem && "/role-management/screen-permissions",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		screenPemrissionsName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IScreenPermissions | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/role-management/screen-permissions/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={isSubmitting || isPendingById || isDeleting || isArchive || isPendingScreensDDL}
				testId="screen permission Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteScreenPermissionsField}
				cancelActionHandler={onCloseHandler}
				testId="screen-permission-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Screen Permissions"
										testId={`screen-permissions`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<ScreenPermissionsInfoSetupFieldsPanel screensDDLList={screensDDL && sortDDLByLabel(screensDDL)} selectedDataRecord={id && selectedDataRecord} />
									</StandardPanel>
								}
								toolbar={
									<ScreenPermissionsSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 3, lg: 3, xl: 3 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 5.5, lg: 5.5, xl: 5.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									screenPemrissionsList && upadtedScreenPermissionsListItems
										? upadtedScreenPermissionsListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Name" },
									{ field: "screenName", headerName: "Screen" },
									{ field: "type", headerName: "Type" },
									{ field: "values", headerName: "List" },
								]}
								showHeaderColumns={true}
								showArchiveIcon={false}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									screenPemrissionsList && screenPemrissionsList.total
										? screenPemrissionsList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveScreenPermissionsField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"screenPemrissions-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
